var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer } from 'antd';
import { useContext } from 'react';
import styled from 'styled-components';
import { MinWidthApp } from '../../../Utils/UtilityFunctions';
import { SecondaryColor, maxMobile, primaryFont, wMedium, } from '../../../Utils/utilsStyle';
import classNames from 'classnames';
import GilroyBackSvg from '../assets/svgIcons/GilroyBackSvg';
import { GilroyContext } from '../../GilroyContext';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nposition: relative;\n.create-group {\n  padding: 0px 30px;\n  @media all and (max-width: ", ") {\n    padding: 0px 16px;\n  }\n}\n"], ["\nposition: relative;\n.create-group {\n  padding: 0px 30px;\n  @media all and (max-width: ", ") {\n    padding: 0px 16px;\n  }\n}\n"])), maxMobile);
var BackGilroyBtn = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\ndisplay: flex;\nalign-items: center;\nposition: absolute;\nleft: -81px;\ntop: 30%;\nfont-family: ", ";\nfont-weight: ", ";\npadding: 4px 10px 3px 8px;\nbackground: ", ";\ncolor: #FFF;\ntransform: rotate(-90deg);\nfont-size: 14px;\nline-height: 12px;\nletter-spacing: -0.3px;\ntext-align: center;\nborder-radius: 6px 6px 0px 0px;\nbox-shadow: -3px 0px 24px 0px rgba(0, 0, 0, 0.10);\nheight: 29px;\nwidth: 133px;\ncursor: pointer;\nsvg {\n  margin-right: 6px;\n  transform: rotate(90deg);\n}\n"], ["\ndisplay: flex;\nalign-items: center;\nposition: absolute;\nleft: -81px;\ntop: 30%;\nfont-family: ", ";\nfont-weight: ", ";\npadding: 4px 10px 3px 8px;\nbackground: ", ";\ncolor: #FFF;\ntransform: rotate(-90deg);\nfont-size: 14px;\nline-height: 12px;\nletter-spacing: -0.3px;\ntext-align: center;\nborder-radius: 6px 6px 0px 0px;\nbox-shadow: -3px 0px 24px 0px rgba(0, 0, 0, 0.10);\nheight: 29px;\nwidth: 133px;\ncursor: pointer;\nsvg {\n  margin-right: 6px;\n  transform: rotate(90deg);\n}\n"])), primaryFont, wMedium, SecondaryColor);
var defaultProps = {
    setTableRowId: function (p) {
        console.log(p);
    },
    docViewGilV3Flag: false,
    customClassName: '',
};
var DrawerDocViewer = function DrawerDocViewer(props) {
    var setDrawerOpen = props.setDrawerOpen, drawerOpen = props.drawerOpen, URL = props.URL, setTableRowId = props.setTableRowId, docViewGilV3Flag = props.docViewGilV3Flag, customClassName = props.customClassName;
    var gilroyActions = useContext(GilroyContext).gilroyActions;
    var isTab = MinWidthApp();
    var onClose = function () {
        setTableRowId(null);
        setDrawerOpen(false);
        gilroyActions.clearPreviewDocument();
    };
    var isGilroyV3 = !window.location.pathname.includes('feed');
    var getFileType = function (type) {
        if (type.includes('/plain')) {
            return 'txt';
        }
        if (type.includes('.document')) {
            return 'docx';
        }
        if (type.includes('.presentation')) {
            return 'pptx';
        }
        if (type.includes('.svg')) {
            return 'svg';
        }
        if (type.includes('.jpeg') || type.includes('.jpg')) {
            return 'jpeg';
        }
        if (type.includes('.png')) {
            return 'png';
        }
        if (type.includes('.xls')) {
            return 'xls';
        }
        if (type.includes('.xlsx')) {
            return 'xlsx';
        }
        if (type.includes('.csv')) {
            return 'csv';
        }
        return 'pdf';
    };
    return (_jsx(Wrapper, { children: _jsxs(Drawer, __assign({ className: classNames("drawer-alerts people-group-drawer doc-viewer ".concat(customClassName), { docViewGilV3: docViewGilV3Flag }), placement: "right", visible: !isTab && drawerOpen, onClose: onClose, destroyOnClose: true }, { children: [docViewGilV3Flag && isGilroyV3 ? (_jsxs(BackGilroyBtn, __assign({ className: "back-to-gilroy-btn", onClick: onClose }, { children: [_jsx(GilroyBackSvg, {}), ' ', "Back To Gilroy"] }))) : null, (getFileType(URL) === 'jpeg' || getFileType(URL) === 'png' || getFileType(URL) === 'svg') ? (_jsx("div", __assign({ className: "drawer-img" }, { children: _jsx("img", { src: URL, alt: "" }) }))) : (_jsx("div", __assign({ style: { height: '100%' } }, { children: _jsx("iframe", { src: URL, title: "file", width: "100%", height: "100%", style: { border: 'none' } }) })))] })) }));
};
DrawerDocViewer.defaultProps = defaultProps;
export default DrawerDocViewer;
var templateObject_1, templateObject_2;
